<app-sticky-container *ngIf="sticky else content">
    <ng-container *ngTemplateOutlet="content"></ng-container>
</app-sticky-container>
<ng-template #content>
    <div [class]="inline ? '' : 'ion-margin'"
         [style.text-align]="textAlignment"
         [style.display]="inline ? 'inline-block' : 'block'"
         *ngIf="loading === true"
         class="loading">
        <mat-progress-spinner
                style="margin: auto;"
                [style.display]="inline ? 'inline-block' : 'block'"
                diameter="20"
                mode="indeterminate">
        </mat-progress-spinner>
        <p *ngIf="showText" class="font-color--accent">{{text}}</p>
    </div>
</ng-template>
